// extracted by mini-css-extract-plugin
module.exports = {"SaleDetailsForm":"AbstractSaleDetailsForm_SaleDetailsForm__24bxA","choocePriceTitle":"AbstractSaleDetailsForm_choocePriceTitle__1wMtX"};